/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconParentheses = createReactComponent("parentheses", "IconParentheses", [
  ["path", { d: "M7 4a12.25 12.25 0 0 0 0 16", key: "svg-0" }],
  ["path", { d: "M17 4a12.25 12.25 0 0 1 0 16", key: "svg-1" }]
]);

export { IconParentheses as default };
//# sourceMappingURL=IconParentheses.js.map
